import { getTheme, GetThemeProps, ThemeValue } from '../getTheme';

export const getThemeFont = (props: GetThemeProps): ThemeValue =>
  `font-family: ${getTheme('text.fontFamily')(props)}`;
